import post from '../../../../fns/http/post'
import getProp from '../../../../fns/object/prop/get'
import getHeaders from './headers/index'

const loadProducts = (params, data, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.se}${getProp(urls, 'services.se.products', '/search/product')}`, data, params, getHeaders({ locale, headers }), {
        responseProxy
    })
}
export default loadProducts
